
export class CustomMedia {

  public id: string = null;
  public caption: string = null;
  public extension: string = null;
  public name: string = null;


  constructor(obj: any) {
    this.id = obj._id;
    this.caption = obj.caption;
    this.extension = obj.extension;
    this.name = obj.name;
  }

  getFile() {
    return this.id + this.extension;
  }

  getPreview() {
    return this.id + '_prev' + this.extension;
  }
}


